import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
/**
 * 
 * This component listens for variant update events and updates the text display accordingly.
 */
class VariantCTAText extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateVariantCTAText);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateVariantCTAText);
  }

  /**
   * Updates the Variant CTA Text
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateVariantCTAText = (event) => {
    console.log(event.target.dataset.productId)
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newVariantCTAText= event.detail.data.html.querySelector('variant-cta-text');
 
    const currentVariantCTAText = this;

    
    if (!newVariantCTAText || !currentVariantCTAText) return;

    if (currentVariantCTAText.innerHTML !== newVariantCTAText.innerHTML) {
      currentVariantCTAText.replaceWith(newVariantCTAText);
    }
  };
}

if (!customElements.get('variant-cta-text')) {
  customElements.define('variant-cta-text', VariantCTAText);
}